import type { IRecents } from "app/@types/userdata";

const createDefaultRecentCompanies = (): IRecents => {
    const today = new Date().toISOString().slice(0, 10);
    const companies = [
        {
            key: "ebay.com",
            companyName: "eBay Inc.",
            favicon:
                "https://site-images-stg.similarcdn.com/image?url=ebay.com&t=2&s=1&h=7f6f9f419ebf2319e686381f48e1ea1bbb2f25fc404930fdfbb3a60985cb6695",
        },
        {
            key: "samsung.com",
            companyName: "Samsung Electronics Co., Ltd.",
            favicon:
                "https://site-images-stg.similarcdn.com/image?url=samsung.com&t=2&s=1&h=acbcd0840863d87073a9c8b029e1f766fd1432cf4d709b92c86a0490904c5c0d",
        },
        {
            key: "rakuten.com",
            companyName: "Rakuten",
            favicon:
                "https://site-images-stg.similarcdn.com/image?url=rakuten.com&t=2&s=1&h=e18a01e7be746b84f28085785c50e61f2c8c5f7f5d4272dd649760682bc559f1",
        },
        {
            key: "walmart.com",
            companyName: "Walmart Inc.",
            favicon:
                "https://site-images-stg.similarcdn.com/image?url=walmart.com&t=2&s=1&h=66a59d35a24ccf994c844e30665fc6d8185c228fbae9a9688803e6b80047e9d3",
        },
        {
            key: "airbnb.com",
            companyName: "Airbnb, Inc.",
            favicon:
                "https://site-images-stg.similarcdn.com/image?url=airbnb.com&t=2&s=1&h=0b1db9e7c2593237c4495a7688b1c2bda79675164a8f64e0371722dba254346c",
        },
    ];
    return companies.map((c) => ({
        id: c.key,
        data: {
            type: "company",
            mainItem: c.key,
            resources: {
                isCompare: false,
                mainItemFavIcon: c.favicon,
                companyName: c.companyName,
            },
        },
        isFavorite: false,
        updatedTime: today,
    }));
};

export default createDefaultRecentCompanies;
